<template>
    <div class="emailtemplate__list_grid">
        <div class="container">
            <div class="columns is-multiline">
                <template v-for="(item, index) in items">
                    <div class="column is-4" :key="index">
                        <emailtemplate-list-grid-item
                            :item="item"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import EmailtemplateListGridItem from './EmailsListGridItem'

export default {
  name: 'emailtemplate-list-grid',
  components: { EmailtemplateListGridItem },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>
